<mat-card class="p-20" style="width: max-content; max-width: 100%; box-sizing: border-box;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Medication Dispenses</mat-card-title>
                <mat-card-subtitle>Track dispensed medications per patient.</mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex" style="flex: 1; justify-content: flex-end;">
                @if (canAddDispense$ | async) {
                <a mat-flat-button extended (click)="openDispenseDialog()">
                    <mat-icon>local_pharmacy</mat-icon>
                    Walk-in Dispense
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>
        <app-table-header [patientsTableFilterArray]="medDispenseTableFilterArray"
            [patientsFiltersFormControlObject]="medDispenseFiltersFormControlObject"
            [searchableFields]="searchableFields"
            [selectedSearchField]="selectedSearchField"
            (filterChanged)="onFilterChanged($event)"
            (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
        </app-table-header>

        <div class="table-container" style="position: relative; min-height: 200px;">
            @if (searchService.loading$ | async) {
            <div class="loading-shade g-just-flex flex-center">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
            }

            @if ((searchService.total$ | async) !== 0) {
            <table mat-table matSort [dataSource]="searchService.dataSource" class="mat-elevation-z8 demo-table mt-20">
            <ng-container matColumnDef="whenHandedOver">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="whenHandedOver">When Dispensed</th>
                <td mat-cell *matCellDef="let disp">
                    <div class="top" style=" padding-top: 6px;">{{ disp.whenHandedOver | date : 'mediumDate' | na }}
                    </div>
                    <div class="bottom subtitle-text-color-2" style="padding-bottom: 6px;">{{ disp.whenHandedOver |
                        date : 'shortTime' | na }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                <td mat-cell *matCellDef="let disp">
                    <div class="g-just-flex flex-column gap-5" style="align-items: flex-start; padding-top: 6px; padding-bottom: 6px;">
                        @if (disp.status) {
                        <div [appChips]="disp.status" [fontSize]="'14px'"></div>
                        } @else {
                        <span class="subtitle-text-color-2">N/A</span>
                        }
                        @if (!disp.authorizingPrescription?.length) {
                        <span [appEmphasis]="'walk-in'" [fontSize]="'11px'">Walk-in</span>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="medication">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="medication">Medication</th>
                <td mat-cell *matCellDef="let disp">
                    <span class="restrict-length" style="white-space: nowrap; padding-top: 6px;padding-bottom: 6px;">{{
                        formatMedication(disp) | na }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="subject">Patient</th>
                <td mat-cell *matCellDef="let disp">
                    @if (disp.subject?.reference) {
                    <div class="top" style="padding-top: 6px;">
                        <span [appReferenceDisplay]="disp.subject.reference" InstantfetchAndRepace="true"></span>
                    </div>
                    <div class="bottom subtitle-text-color-2" style="padding-bottom: 6px;">
                        {{ disp.subject.reference | referenceIdentifier | async }}
                    </div>
                    } @else {
                    <span class="subtitle-text-color-2">N/A</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="quantity">Qty</th>
                <td mat-cell *matCellDef="let disp">
                    {{ formatQuantity(disp) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let disp">
                    <button mat-icon-button (click)="showRow(disp)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <mat-paginator
            [length]="(searchService.total$ | async) || 0"
            [pageSize]="25"
            [pageSizeOptions]="[25]"
            (page)="searchService.changePage($event.pageIndex)"
            showFirstLastButtons>
        </mat-paginator>

        } @else {
        <app-empty-state class="py-40" [icon]="'MEDICAL_SERVICES'" [title]="'No Medication Dispenses Found'"
            [subtitle]="'Record a dispense to begin tracking inventory updates.'">
        </app-empty-state>
        }
        </div>
    </mat-card-content>
</mat-card>